import { apiClient as ApiClient } from 'modules/core/lib/mobx-rest'

import IntegrationCodes from 'modules/marketplace/lib/integrationCodes'

export default async function fetchCountByPeriod(policyPeriodId: number): Promise<number> {
  const api = ApiClient()

  const SUPPLEMENTS_PATH = `/integrations/${IntegrationCodes.silae_api}/supplements`
  const response = await api.get(SUPPLEMENTS_PATH, { policy_period_id: policyPeriodId })

  return response.count
}
